module.exports = __webpack_public_path__ + "static/media/configurationsIcons.5874df43.svg";